import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Row, Col } from 'react-bootstrap';

const AboutSection = () => {
    const [receivedData, setReceivedData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/AboutUs/active`);
                setReceivedData(response.data[0]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <Container>
    
                    {receivedData && (
                        <div dangerouslySetInnerHTML={{ __html: receivedData.description }} />
                    )}
               
        </Container>
    );
};

export default AboutSection;
